import {Injectable} from "@angular/core";
import {environment} from '../../environments/environment';
import {HttpClient} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {ClientsRootPayloadModelList, CreateClientPayloadModel} from './client_interfaces';


@Injectable({providedIn: 'root'})
export class ClientService {


  url:string = `${environment['API_URL']}`

  constructor(private http: HttpClient,) {
  }

  getClients(endpoint: string, is_mocked: boolean = false): Observable<ClientsRootPayloadModelList> {

    if(is_mocked) {
      return of<ClientsRootPayloadModelList>(
        [
          {
            "client_id": 1,
            "client_slug": "mock",
            "name": "Mock Client"}
        ]
      )
    }

    let url: string = `${this.url}/${endpoint}`;
    return this.http.get<ClientsRootPayloadModelList>(url);
  } //end getClients

  post(endpoint: string, data: CreateClientPayloadModel){
    return this.http.post<any>(`${this.url}/${endpoint}`, data,{observe: 'response'});
  } //end post

  put(endpoint: string, data: any){
    return this.http.post(`${this.url}/${endpoint}`, data,{observe: 'response'});
  }

  delete(endpoint: string){
    let url = `${this.url}/${endpoint}`;

    console.log("Deleting client with endpoint:", endpoint);
    return this.http.delete(url);
  } //end login



} //
